import { render, staticRenderFns } from "./SalaryAuditEditor.vue?vue&type=template&id=66070eb0&scoped=true&"
import script from "./SalaryAuditEditor.vue?vue&type=script&lang=js&"
export * from "./SalaryAuditEditor.vue?vue&type=script&lang=js&"
import style0 from "./SalaryAuditEditor.vue?vue&type=style&index=0&id=66070eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66070eb0",
  null
  
)

export default component.exports